import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "./apiClient";
import { IClientResponse } from "src/types/clients";

export const useGetProfile = () =>
  useQuery<any, APIErrorResponse, { data: IClientResponse }>({
    queryKey: ["get-profile"],
    queryFn: async () => {
      return apiClient.get(`/client/profile`);
    },
    gcTime: 0,
  });

export const useDeleteClientAccountMutation = () =>
  useMutation<any, APIErrorResponse, { clientId: string; accountId: string }>({
    mutationFn: async (data) => {
      const { clientId, accountId } = data;
      return apiClient.delete(
        `/client/${clientId}/linkedAccounts/${accountId}`
      );
    },
  });
